import { render, staticRenderFns } from "./ggzSelect.vue?vue&type=template&id=ec05becc"
import script from "./ggzSelect.vue?vue&type=script&lang=js"
export * from "./ggzSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports